import {getDecimal} from "../config/utils";

export const validateAddBalance = (balance, selectedBals, selectedPlans, court) => {
    const nextItem = '; ';
    let errors = '';
    if (balance.partialAmt && balance.partialAmt > 0) {
        if (balance.noPartialPayment || (court.acceptPartials !== null && !court.acceptPartials)) {
            errors = 'Partial payments are not allowed';
        } else if (balance.minimumPartialAmount && balance.minimumPartialAmount > 0 && balance.balancePaymentAmount < balance.minimumPartialAmount) {
            errors = `A partial payment for this balance must be at least $${getDecimal(balance.minimumPartialAmount, false)}`;
        }
    }
    if (selectedPlans && selectedPlans.length > 0) {
        selectedPlans.forEach(p => {
            if (p.cases && p.cases.includes(balance.caseNumber)) {
                if (errors) errors += nextItem;
                errors += `${court.nonCourtOrganization ? 'Account ' : 'Case '}${balance.caseNumber} cannot be included in a payment plan and paid separately`;
            }
        })
    }
    if (balance.trafficSchoolId) {
        const tsBals = selectedBals.filter(b => b.trafficSchoolId);
        if (tsBals && tsBals.length > 0) errors += 'Only one traffic school option may be selected';
    }
    return errors;
}

export const validateAddPlan = (plan, selectedBals, selectedPlans, court) => {
    const nextItem = '; ';
    let errors = '';
    if (!plan.installments || plan.installments.filter(i => i.checked).length < 1) {
        errors = 'You must check at least one installment to make a payment on a payment plan';
    } else {
        let lastSelected = 0;
        plan.installments.forEach((i) => {
            if (i.checked) {
                if (i.priorityOrder - lastSelected > 1) {
                    if (errors) errors += nextItem;
                    errors += 'Installments on a payment plan must be paid in the order displayed';
                }
                lastSelected = i.priorityOrder;
            }
        })
    }
    if (selectedBals && selectedBals.length > 0) {
        selectedBals.forEach(b => {
            if (plan.cases && plan.cases.includes(b.caseNumber)) {
                if (errors) errors += nextItem;
                errors += `${court.nonCourtOrganization ? 'Account ' : 'Case '}${b.caseNumber} may not be included in a payment plan and paid separately`;
            }
        })
    }
    if (selectedPlans && selectedPlans.length > 0) {
        selectedPlans.forEach(p => {
            if (p.cases) {
                const caseArray = p.cases.split(',');
                caseArray.forEach(c => {
                    if (plan.cases && plan.cases.includes(c)) {
                        if (errors) errors += nextItem;
                        errors += `${court.nonCourtOrganization ? 'Account ' : 'Case '}${c} may only be included in one payment plan in a payment`;
                    }
                })
            }
        })
    }
    return errors;
}

export const getPaymentRequest = (court, selectedBalances, selectedPlans, feeResponse) => {
    const serviceFee = getServiceFee(selectedBalances, selectedPlans);
    return {
        courtId: court.courtId,
        paymentDescription: `Payment for: ${selectedBalances.length > 0 ? selectedBalances[0].caseNumber : selectedPlans[0].planDescription}`,
        partyName: selectedBalances.length > 0 ? selectedBalances[0].partyName : selectedPlans[0].balances[0].partyName,
        courtAmount: feeResponse.courtAmount,
        feeAmount: feeResponse.citepayFee,
        totalAmount: feeResponse.totalAmount,
        serviceFee: serviceFee > 0 ? serviceFee : null,
        processingType: 'online',
        paymentCategory: 'MOTO',
        paymentLocation: 'Virtual Terminal',
        sourceApp: 'virtualTerminal',
        balances: selectedBalances,
        paymentPlans: selectedPlans
    };
}

export const getServiceFee = (balances, plans) => {
    let serviceFee = 0;
    if (balances && balances.length > 0) {
        balances.forEach(b => {
            if (b.serviceFee && b.serviceFee > 0) {
                serviceFee += b.serviceFee;
            }
        })
    }
    if (plans && plans.length > 0) {
        plans.forEach(p => {
            if (p.planPaymentServiceFee && p.planPaymentServiceFee > 0) {
                serviceFee += p.planPaymentServiceFee;
            }
        })
    }
    return parseFloat(getDecimal(serviceFee, false));
}

export const getCourtAmount = (selectedBals, selectedPlans) => {
    let total = 0;
    if (selectedBals && selectedBals.length > 0) {
        selectedBals.forEach(b => {
            total = total + b.balancePaymentAmount;
            total = parseFloat(getDecimal(total, false));
        });
    }
    if (selectedPlans && selectedPlans.length > 0) {
        selectedPlans.forEach(p => {
            total = total + p.planPaymentAmount
            total = parseFloat(getDecimal(total, false));
        });
    }
    return total;
}

export const validatePayment = (selectedBalances, court) => {
    let errors = '';
    if (court.minimumPartial && court.minimumPartial > 0) {
        const partialAmt = getPartialAmount(selectedBalances);
        if (partialAmt && partialAmt > 0 && partialAmt < court.minimumPartial) {
            errors += `Partial payments for the ${court.courtName} must be at least $${getDecimal(court.minimumPartial)}`;
        }
    }
    return errors;
}

const getPartialAmount = (balances) => {
    let partialAmt = 0;
    if (balances && balances.length > 0) {
        balances.forEach(b => {
            if (b.partialAmt && b.partialAmt > 0) partialAmt += b.balancePaymentAmount;
        });
        partialAmt = parseFloat(getDecimal(partialAmt, false));
    }
    return partialAmt;
}
